import classnames from "classnames";

import { useSelector } from "seneca-common/utils/hooks/selectors";

import useAppVariant from "features/common/hooks/useAppVariant";
import { isLocalizeLoaded } from "features/common/localisation/utils";
import { getSplashScreenBackgroundColor } from "features/dark-mode/utils";
import { getRegion } from "features/regions/selectors";

import "./SplashScreen.scss";

type Props = {
  className?: string;
};

export default function SplashScreen({ className }: Props) {
  const backgroundColor = getSplashScreenBackgroundColor();
  const logoClassNames = useVariants();

  return (
    <div
      className={classnames("SplashScreen__wrapper", className)}
      style={{ backgroundColor }}
    >
      <div className={`SplashScreen__logo ${logoClassNames}`} />
    </div>
  );
}

function useVariants() {
  const appVariant = useAppVariant();
  const region = useSelector(getRegion);
  const showGoStudentLogo = (region && region !== "GB") || isLocalizeLoaded();

  const valuesByVariant = {
    seneca: showGoStudentLogo
      ? "SenecaByGoStudentLogo__logo"
      : "LightBlueLogo__logo",
    senecaPrimary: "LightBlueLogo__logo",
    plurall: "PlurallLogo__logo",
    goStudentLearning: "GoStudentLearningLogo__logo"
  };

  return valuesByVariant[appVariant];
}
